import routerOptions0 from "/home/runner/work/JRK-Digital-Portal-Obcana/JRK-Digital-Portal-Obcana/resources/nuxt/admin/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}